import styled from '@emotion/styled'
import type { FC } from 'react'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroRecipeBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Which plan is right for me?`,
  description: (
    <>
      <p>
        At Segment, we want to equip you with the expertise you need to be successful. For access to technical support
        and additional Support resources, we offer plans to fit your unique needs.
      </p>
      <p>
        Professional Services is a separate offer that accelerates time to value with Segment advisory, jumpstart, and
        resident architect programs. It can be purchased in addition to any Support plan.
      </p>
    </>
  ),
}

const button = {
  text: `View Support Plans`,
  url: `/support-plans/`,
}

const Hero: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <HeroRecipeBase variant="centered" copyVariant="wide">
        <HeroRecipe.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <StyledCopyTextDescription tag="h2" variant="pExtraLarge">
              {copy.description}
            </StyledCopyTextDescription>
          </CopyTextBase>
        </HeroRecipe.Copy>
        <HeroRecipe.Contents>
          <ButtonText href={getAbsoluteUrl(button.url, pageConfig)} iconEnd={ChevronRightIcon}>
            {button.text}
          </ButtonText>
        </HeroRecipe.Contents>
      </HeroRecipeBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledCopyTextDescription = styled(CopyText.Description)`
  p:not(:first-of-type) {
    margin-top: 24px;
  }
`

export default Hero
